module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Gc-Ha-Ia.a151e47d.png";